module.exports = __webpack_public_path__ + "packs/media/images/Registration_Step_10a-e3c030ea41f709e056eb7e463c1574dd.jpg";